module.exports = __webpack_public_path__ + "static/media/logo.203b9d68.svg";